import React from 'react'
import appConstants from './../../../../constants/appConstants'
import env from './../../../../environments/environment'
import './HomeLogoShowcase.component.scss'

const HomeLogoShowcase = () => {
  return (
    <section className='home-logo-showcase'>
      <div className='home-logo-showcase__row'>
        <div className='home-logo-showcase__col'>
          <img
            src={appConstants.badges.experience}
            alt='USA Benefits Group logo: red ribbon with "1988" and "2026", gold seal with "38 YEARS", and "GROUP" below.'
          />
        </div>
        <div className='home-logo-showcase__col'>
          <img
            src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.bbb.png?alt=media`}
            alt='BBB Accredited Business logo, blue and white, with an A+ rating.'
          />
        </div>
      </div>
    </section>
  )
}

export default HomeLogoShowcase
